module.exports = __webpack_public_path__ + "img/micro-small.505ec05c.svg";